function FooterDesktop() {
  return (
    <div className="pb-12 text-[16px] ">
      <p className="mt-1 ">I built my portfolio from scratch.</p>

      {/* <div className="flex flex-wrap text-gray-4">
        <p className="mr-1">Loosely designed in</p>
        <p className="mr-1 text-custom-white">Figma</p>
        <p className="mr-1">and coded in</p>
        <p className="mr-1 text-custom-white">Visual Studio Code</p>
        <p className="mr-1">by yours truly.</p>
        <p className="mr-1">Built with</p>
        <p className="mr-1 text-custom-white">React.js</p>
        <p className="mr-1">and</p>
        <p className="mr-1 text-custom-white">Tailwind CSS</p>
        <p className="mr-1">, deployed with</p>
        <p className="mr-1 text-custom-white">Vercel.</p>
      </div> */}

      <p className="mt-1 text-gray-4">Inspired by viral memes and big dreams :]</p>
    </div>
  );
}

export default FooterDesktop;
